import Vue from 'vue'
import * as actionHelper from '@/modules/app/helpers/actions'
import Inspection from '@/modules/inspections/models/inspection'

export default {
  getAllInspections (store, payload) {
    return new Promise((resolve, reject) => {
      const url = actionHelper.prepareGetAllURL(payload, 'inspection', ['site', 'branch', 'inspector', 'group'])
      return Vue.axios.get(url)
        .then(res => resolve(
          {
            items: Inspection.fromJsonArray(res.data.data),
            pagination: res.data.meta.pagination
          }))
        .catch(err => reject(err))
    })
  },
  assignInspectorToInspections (store, payload) {
    const params = actionHelper.urlSearchParamsFromProperties(payload)
    return Vue.axios.post(`staff/${payload.inspector_id}/assign`, params)
  }
}
